module.exports = __webpack_public_path__ + "02_short_beige.bf2d84c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_short_beige.png
// module id = voC8
// module chunks = 0